import { useGetAdmins } from "@entities/admin";
import { CircularProgress } from "@shared/ui";
import { Avatar, Select, Space } from "antd";
import { useState } from "react";

import styles from "./styles.module.scss";
import { Button } from "@shared/ui/Button";
import { useGetBrands } from "@entities/brand";

interface Props {
  alreadyAddedUsers: string[];
  onSubmit: (value: string[]) => void;
  isSubmitting: boolean;
  isLinked: boolean;
}

const { Option } = Select;

export function AddBillingBrand({
  alreadyAddedUsers,
  onSubmit,
  isSubmitting,
  isLinked,
}: Props) {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [selectedAdmin, setSelectedAdmin] = useState<string[]>([]);

  const { brands: adminsData, isFetching } = useGetBrands(10, 1, searchQuery);
  const admins = adminsData?.data || [];
  const handleSearch = (value: string) => {
    setSearchQuery(value);
  };

  return (
    <div style={{ display: "grid", gap: "16px", marginTop: 16 }}>
      <Select
        showSearch
        mode="multiple"
        placeholder="Search and select a brand"
        onSearch={handleSearch}
        onChange={(value) => setSelectedAdmin(value)}
        filterOption={false}
        notFoundContent={
          isFetching ? <CircularProgress size="small" /> : "No admins found"
        }
        style={{ width: "100%" }}
      >
        {(admins || [])
          .filter((admin) => !alreadyAddedUsers.includes(admin._id))
          .map((admin) => (
            <Option key={admin._id} value={admin._id}>
              <Space align="center">{admin.name}</Space>
            </Option>
          ))}
      </Select>
      <div className={styles.footer}>
        <Button
          key="create"
          type="primary"
          onClick={() => onSubmit(selectedAdmin || "")}
          disabled={!selectedAdmin.length}
          loading={isSubmitting}
        >
          Add
        </Button>
      </div>
    </div>
  );
}
